/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenWithSecretUpdate
 */
export interface APITokenWithSecretUpdate {
    /**
     * 
     * @type {string}
     * @memberof APITokenWithSecretUpdate
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof APITokenWithSecretUpdate
     */
    name: string;
}

export function APITokenWithSecretUpdateFromJSON(json: any): APITokenWithSecretUpdate {
    return APITokenWithSecretUpdateFromJSONTyped(json, false);
}

export function APITokenWithSecretUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenWithSecretUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
        'name': json['name'],
    };
}

export function APITokenWithSecretUpdateToJSON(value?: APITokenWithSecretUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'name': value.name,
    };
}


